var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"text-end"},[_vm._v(" "+_vm._s(_vm.$t("labels.copyright"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }